import {
	createWebSocket
} from './Swebsocket.js';
import store from '../store';
import {
	Getitem,
	Setitem
} from "@/utils/item.js"

let currentWsInstance = null;

export async function WSinit(clientId, userId) {
	const TOKENkey = `${clientId}_${userId}`;
	store.commit('setTokenName', TOKENkey)

	// 1. 先关闭旧连接
	await closeExistingConnection();

	// 2. 校验参数
	if (!clientId || !userId) {
		// console.error('缺少clientId或userId，无法初始化WebSocket');
		return;
	}

	// 3. 创建新实�?
	currentWsInstance = createWebSocket(clientId, userId);

	// 4. 初始化连�?
	currentWsInstance.init();

	// 5. 存储�?Vuex
	store.commit('setmews', currentWsInstance);

	// 6. 设置消息回调
	setupMessageHandler(currentWsInstance, TOKENkey);

	// console.log('WebSocket已重新初始化（新用户�?);
}

export function closeWs() {
	if (currentWsInstance) {
		currentWsInstance.close();
		currentWsInstance = null;
	}

	// 清空 Vuex 数据
	store.commit('setmews', null);
	store.commit('setonline', false);
	store.commit('setmessages', []);
	// console.log('已关闭WebSocket连接并清空数�?);
}

// 辅助函数：关闭现有连�?
function closeExistingConnection() {
	return new Promise((resolve) => {
		const oldWsInstance = store.state.mews;

		if (!oldWsInstance) {
			resolve();
			return;
		}

		// 设置关闭监听
		const checkClose = () => {
			if (!store.state.mews || !store.state.mews.getIsOnline()) {
				// console.log('旧WebSocket连接已完全关�?);
				resolve();
			} else {
				setTimeout(checkClose, 100);
			}
		};

		// console.log('开始关闭旧WebSocket连接...');
		oldWsInstance.close();
		checkClose();
	});
}

// 辅助函数：设置消息处理器（统一处理单条/多条消息，减少重复代码）
function setupMessageHandler(wsInstance, TOKENkey) {
	wsInstance.setOnMessageCallback(async (message) => {
		// 1. 过滤系统消息
		if (['pong', 'online', 'noline'].includes(message)) {
			return;
		}

		// 2. 校验message基础类型（避免后续访问content时报错）
		if (typeof message !== 'object' || message === null) {
			// console.warn('收到非对象类型消息，跳过处理:', message);
			return;
		}

		// 3. 统一提取消息列表（支持message.content是数组或单条，或message本身是数组）
		let messageList = [];
		if (Array.isArray(message.content)) {
			// 情况1：message.content是数组（多条消息�?
			messageList = message.content;
		} else if (message.content) {
			// 情况2：message.content是单条消息（非数组）
			messageList = [message.content];
		} else {
			// 情况3：无content字段，message本身是单条消�?
			messageList = [message];
		}

		// 4. 遍历处理每条消息（错误隔离，单条失败不影响其他）
		for (const msgItem of messageList) {
			try {
				const messageData = await processMessageData(msgItem, TOKENkey);
				if (messageData?.Dshmsg) {

					store.commit('setnewchat', messageData.Dshmsg);
				}
			} catch (error) {
				// console.error('处理单条消息失败:', error, '消息�?', msgItem);
				continue;
			}
		}
	});
}

// 辅助函数：处理单条消息数据（增强校验，避免JSON解析错误�?
async function processMessageData(msgItem, TOKENkey) {
	// console.log('处理单条消息�?', msgItem);

	// 1. 校验msgItem是否为有效对�?
	if (typeof msgItem !== 'object' || msgItem === null) {
		// console.warn('无效的消息项（非对象），跳过:', msgItem);
		return null;
	}

	// 2. 安全获取shmsg（兼容msgItem本身是消息体，或包含content字段�?
	let shmsg = msgItem.content ? msgItem.content : msgItem;

	// 3. 校验shmsg的必要字段（避免后续解析报错�?
	if (!shmsg?.msg || !shmsg?.type) {
		// console.warn('消息缺少msg或type字段，跳�?', shmsg);
		return null;
	}

	// 4. 安全解析JSON（避免解析失败导致整体报错）
	let parsedMsg, parsedType;
	try {
		parsedMsg = typeof shmsg.msg === 'string' ? JSON.parse(shmsg.msg) : shmsg.msg;
		parsedType = typeof shmsg.type === 'string' ? JSON.parse(shmsg.type) : shmsg.type;
	} catch (parseError) {
		// console.error('解析msg或type失败:', parseError, '消息�?', shmsg);
		return null;
	}

	// 5. 构造标准消息格�?
	const Dshmsg = {
		isOther: true,
		msg: parsedMsg,
		type: parsedType,
		sendUser: shmsg.toUser || '', // 兜底空字符串，避免undefined
		toUser: shmsg.sendUser || '' // 兜底空字符串，避免undefined
	};

	// 6. 存储到本地（token和列表）
	await storeToToken(TOKENkey, Dshmsg);
	await storeToList(TOKENkey, Dshmsg);

	return {
		Dshmsg
	};
}

// 辅助函数：存储到 token
async function storeToToken(TOKENkey, shmsg) {
	try {
		const s = shmsg.toUser;
		const Msgtokenname = `${TOKENkey}_${s}`;
		let tokenmsgs = await Getitem(Msgtokenname) || [];
		tokenmsgs.push(shmsg);
		await Setitem(Msgtokenname, tokenmsgs);
	} catch (error) {
		// console.error('存储到token失败:', error);
	}
}

// 辅助函数：存储到列表
async function storeToList(TOKENkey, shmsg) {
	try {
		const window = store.state.Swindow;
		shmsg.unread = window !== shmsg.toUser; // 标记未读状�?

		const listname = `${TOKENkey}_list`;
		let listmsgs = await Getitem(listname) || [];

		// 去重并将最新消息前�?
		listmsgs = listmsgs.filter(res => res.toUser !== shmsg.toUser);
		listmsgs.unshift(shmsg);

		await Setitem(listname, listmsgs);
	} catch (error) {
		// console.error('存储到列表失�?', error);
	}
}
